import * as t from 'io-ts'

/** GPS coordinates */
export const Coordinates = t.type({
  lat: t.number,
  lng: t.number,
})
export type Coordinates = t.TypeOf<typeof Coordinates>